import { render, staticRenderFns } from "./IpoBrokerAccountRow.vue?vue&type=template&id=5be2fd92"
import script from "./IpoBrokerAccountRow.vue?vue&type=script&lang=js"
export * from "./IpoBrokerAccountRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports